import { render } from "./signup-step-account.vue?vue&type=template&id=54c48828&scoped=true&ts=true"
import script from "./signup-step-account.vue?vue&type=script&lang=ts"
export * from "./signup-step-account.vue?vue&type=script&lang=ts"

import "./signup-step-account.vue?vue&type=style&index=0&id=54c48828&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c48828"]])

export default __exports__